module.exports = __webpack_public_path__ + "img/image61.36873549.png";